import { lazy } from "react";
import AuthGuard from "./auth/AuthGuard";
import { authRoles } from "./auth/authRoles";
import Loadable from "./components/Loadable";
import MatxLayout from "./components/MatxLayout/MatxLayout";
import LogInLayout from "./utils/LogInLayout";
import EmployeeGuard from "./auth/EmployeeGuard";
import CheckInOutGaurd from "./auth/CheckInOutGaurd";
import CompanyGuard from "./auth/CompanyGuard";
import AddLeaveType from "./views/leaveManagement/admin/AddEditLeaveType";
import OfferLanding from "./views/sessions/offer/OfferLanding";
import HomePage from "./views/sessions/Landing-page-component/HomePage";
import ActivityTracking from "./views/sessions/Landing-page-component/ActivityTracking";
import LeaveMangement from "./views/sessions/Landing-page-component/LeaveMangement";
import RealTimeInsights from "./views/sessions/Landing-page-component/RealTimeInsight";
import WorkFromHome from "./views/sessions/Landing-page-component/WorkFromHome";
import Blogs from "./views/sessions/Landing-page-component/Blogs";
import FAQ from "./views/sessions/Landing-page-component/Faq";
import DetailedComplianceReports from "./views/sessions/Landing-page-component/DetailedComplianceReports";
import VisitorMangement from "./views/sessions/Landing-page-component/VisitorManegement";
import Pricing from "./views/sessions/Landing-page-component/Pricing";
import ContactUs from "./views/sessions/Landing-page-component/ContactUs";
import AboutUs from "./views/sessions/Landing-page-component/AboutUs";
import Blog1 from "./views/sessions/Landing-page-component/blog-component/Blog1";
import AttandanceManagement from "./views/sessions/Landing-page-component/blog-component/AutomatedAttendanceManagement";
import HowAttendanceManagementSoftwareImproves from "./views/sessions/Landing-page-component/blog-component/HowAttendanceManagementSoftwareImproves";
import TopBenefitsofImplementingAttendance from "./views/sessions/Landing-page-component/blog-component/TopBenefitsofImplementingAttendance";
import HowBoostsProductivityandReducesCosts from "./views/sessions/Landing-page-component/blog-component/HowBoostsProductivityandReducesCosts";
import TheFutureofEmployeeTime from "./views/sessions/Landing-page-component/blog-component/TheFutureofEmployeeTime";
import WhyYourComapnyNeeds from "./views/sessions/Landing-page-component/blog-component/WhyYourComapnyNeeds";
import AdvancedTrackingSolutionsHelp from "./views/sessions/Landing-page-component/blog-component/AdvancedTrackingSolutionsHelp";
import StreamliningHROperations from "./views/sessions/Landing-page-component/blog-component/StreamliningHROperations";
import KeyFeaturestoLookAttandance from "./views/sessions/Landing-page-component/blog-component/KeyFeaturestoLookAttandance";
import CommonAttendanceManagement from "./views/sessions/Landing-page-component/blog-component/5CommonAttendanceManagement";
import BoostingEmployeeAccountability from "./views/sessions/Landing-page-component/blog-component/BoostingEmployeeAccountability";
import Enhancingremotework from "./views/sessions/Landing-page-component/blog-component/Enhancingremotework";
import TheImportanceofAttendance from "./views/sessions/Landing-page-component/blog-component/TheImportanceofAttendance";
import HowtochoosetherightAttendancemanagement from "./views/sessions/Landing-page-component/blog-component/HowtochoosetherightAttendancemanagement";
import RealTimeAttendanceTrackingBenefits from "./views/sessions/Landing-page-component/blog-component/Real-TimeAttendanceTrackingBenefits";
import AutomatedAttendanceSolutions from "./views/sessions/Landing-page-component/blog-component/AutomatedAttendanceSolutions";
import BoostBusinessEfficiency from "./views/sessions/Landing-page-component/blog-component/BoostBusinessEfficiency";
import OptimizingEmployeeSchedulesWithAttendanceManagementSoftware from "./views/sessions/Landing-page-component/blog-component/OptimizingEmployeeSchedulesWithAttendanceManagementSoftware";
import HRTechnologyTrendsToWatchOut from "./views/sessions/Landing-page-component/blog-component/HRTechnologyTrendsToWatchOut";
import TheBestWayToTrackTimeAttendanceOfYourRemoteTeam from "./views/sessions/Landing-page-component/blog-component/TheBestWayToTrackTimeAttendanceOfYourRemoteTeam";
// import materialRoutes from 'app/views/material-kit/MaterialRoutes';

// session pages
const NotFound = Loadable(lazy(() => import("app/views/sessions/NotFound")));
const JwtLogin = Loadable(lazy(() => import("app/views/sessions/JwtLogin")));
const JwtAdminLogin = Loadable(
  lazy(() => import("app/views/sessions/JwtAdminLogin"))
);
const JwtLRegisterCompany = Loadable(
  lazy(() => import("app/views/sessions/JwtLRegisterCompany"))
);
const VerifyEmail = Loadable(
  lazy(() => import("app/views/sessions/VerifyEmail"))
);
const JwtRegister = Loadable(
  lazy(() => import("app/views/sessions/JwtRegister"))
);
const ForgotPassword = Loadable(
  lazy(() => import("app/views/sessions/ForgotPassword"))
);
const AdminForgotPassword = Loadable(
  lazy(() => import("app/views/sessions/AdminForgotPassword"))
);

// echart page
const AppEchart = Loadable(
  lazy(() => import("app/views/charts/echarts/AppEchart"))
);
// comapony  page
const CompanyList = Loadable(lazy(() => import("app/views/company/list")));
const AddCompany = Loadable(lazy(() => import("app/views/company/add")));
// employees page
const EmployeesTable = Loadable(lazy(() => import("app/views/employees/list")));
const AddEmployee = Loadable(lazy(() => import("app/views/employees/add")));
const EditEmployee = Loadable(lazy(() => import("app/views/employees/edit")));
const AdminList = Loadable(lazy(() => import("app/views/employees/AdminList")));
// const TodayAttendaceList = Loadable(lazy(() => import("app/views/employees/attendance/todayList")));

// checkinout
const Checkinout = Loadable(
  lazy(() => import("app/views/checkinout/checkinout"))
);
const Checkoutlist = Loadable(
  lazy(() => import("app/views/checkinout/checkoutlist"))
);
const EmployeeAttendanceList = Loadable(
  lazy(() => import("app/views/checkinout/attendanceList"))
);
const EmployeeLeave = Loadable(
  lazy(() => import("app/views/checkinout/EmployeeLeave"))
);

// Roles
const RoleList = Loadable(lazy(() => import("app/views/roles/roles")));
const AddRole = Loadable(lazy(() => import("app/views/roles/AddRoles")));
const EditRole = Loadable(lazy(() => import("app/views/roles/EditRole")));
// const Checkoutlist = Loadable(lazy(() => import('app/views/checkinout/checkoutlist')));
const Approval = Loadable(lazy(() => import("app/views/Deskstop/ApproveList")));
// stting page
const Setting = Loadable(lazy(() => import("app/views/setting/Setting")));
//profile
const Profile = Loadable(lazy(() => import("app/views/profile/profile")));
const ChangePassword = Loadable(
  lazy(() => import("app/views/profile/ChangePassword"))
);

// dashboard page
const Analytics = Loadable(lazy(() => import("app/views/dashboard/Analytics")));
// Report Page
const ReportsTab = Loadable(
  lazy(() => import("app/views/reports/ReportsTab"))
);
// Leave Page
const Leaves = Loadable(
  lazy(() => import("app/views/employees/leaves/LeaveTab"))
);
const LandingPage = Loadable(
  lazy(() => import("app/views/sessions/LandingPage"))
);

//vistor
const VisitorList = Loadable(lazy(() => import("app/views/visitor/list")));

//Holiday
const Holiday = Loadable(lazy(() => import("app/views/holiday/Holiday")));
const AddHoliday = Loadable(
  lazy(() => import("app/views/holiday/Add_Holiday"))
);
const HolidayCalender = Loadable(
  lazy(() => import("app/views/holiday/HolidayTab"))
);

//Employee Dashboard
const EmployeeDashboard = Loadable(
  lazy(() => import("app/views/employee-dashboard/employee-dashboard"))
);
//Employee calende
const EmployeeCalendar = Loadable(
  lazy(() => import("app/views/employee-calendar/employee-calendar"))
);

//Employee logs
const EmployeActivityTab = Loadable(
  lazy(() => import("app/views/employee-log/EmployeActivityTab"))
);

//System Dashbaord
const SystemDashboard = Loadable(
  lazy(() => import("app/views/system-dashboard/systemDashboard"))
);

//System Dashbaord
const Requests = Loadable(
  lazy(() => import("app/views/employees/requests/requests"))
);
// project label
const ProjectLabel = Loadable(
  lazy(() => import("app/views/project-label/project-label"))
);
//Leave Management system

const LeaveType = Loadable(
  lazy(() => import("app/views/leaveManagement/admin/LeaveType"))
);
const LeaveTracker = Loadable(
  lazy(() => import("app/views/leaveManagement/admin/LeaveTracker"))
);
const EmployeeLeaveList = Loadable(
  lazy(() => import("app/views/leaveManagement/admin/EmployeeLeaves"))
);
const LeaveCofiguration = Loadable(
  lazy(() => import("app/views/leaveManagement/admin/LeaveConfiguration"))
);

const LeaveReport = Loadable(
  lazy(() => import("app/views/leaveManagement/admin/LeaveReport"))
);

const EmployeeLeaveBalance = Loadable(
  lazy(() => import("app/views/leaveManagement/admin/EmployeeLeaveBalance"))
);
const LeaveReconcilation = Loadable(
  lazy(() => import("app/views/leave-reconcilation/LeaveReconcilation"))
);

const CronJobs = Loadable(lazy(() => import("app/views/cron-job/cron-job")));

const Plan = Loadable(lazy(() => import("app/views/company-plan/Plan")));

const EmployeeActivityLogsData = Loadable(
  lazy(() => import("app/views/employee-log/employee-activity/EmployeeActivityLogData"))
);

const EmployeLopTab = Loadable(
  lazy(() => import("app/views/leaveManagement/admin/lop-adjustment/EmployeLopTab"))
);

const routes = [
  {
    element: (
      <AuthGuard>
        <MatxLayout />
      </AuthGuard>
    ),
    children: [
      // ...materialRoutes,
      // dashboard route
      {
        path: "/dashboard",
        element: <Analytics />,
        auth: authRoles.admin,
      },
      {
        path: "/timesheet-list",
        element: <ProjectLabel />,
        auth: authRoles.admin,
      },

      // e-chart rooute
      {
        path: "/charts/echarts",
        element: <AppEchart />,
        auth: authRoles.editor,
      },
      {
        path: "/employees/list",
        element: <EmployeesTable />,
        // element: <Checkoutlist />,
        auth: authRoles.employee,
      },

      // {
      //   path: "/checkInOut",
      //   // element: <EmployeesTable />,
      //   element: <Checkinout />,
      //   auth: authRoles.employee,
      // },
      {
        path: "/admin_attendance_list",
        element: <AdminList />,
        // auth: authRoles.sa,
      },
      {
        path: "/employees/add",
        element: <AddEmployee />,
        auth: authRoles.editor,
      },
      {
        path: "/employees/edit",
        element: <EditEmployee />,
        auth: authRoles.editor,
      },
      {
        path: "/checkinout/checkoutlist",
        element: <Checkinout />,
        auth: authRoles.editor,
      },
      // {
      //   path: '/employees/edit',
      //   element: <Checkoutlist />,
      //   auth: authRoles.editor
      // },
      {
        path: "/profile/profile",
        element: <Profile />,
        auth: authRoles.editor,
      },
      {
        path: "/roles/roles",
        element: <RoleList />,
        auth: authRoles.editor,
      },
      {
        path: "/roles/add",
        element: <AddRole />,
        auth: authRoles.editor,
      },
      {
        path: "/roles/Edit",
        element: <EditRole />,
        auth: authRoles.editor,
      },
      {
        path: "/approvals",
        element: <Approval />,
        auth: authRoles.editor,
      },
      {
        path: "/employee/requests",
        element: <Requests />,
        auth: authRoles.editor,
      },
      {
        path: "/setting",
        element: <Setting />,
        auth: authRoles.editor,
      },
      {
        path: "/employees/report",
        element: <ReportsTab />,
        auth: authRoles.editor,
      },
      {
        path: "/employees/activity-tracking",
        element: <EmployeActivityTab />,
        auth: authRoles.editor,
      },
      {
        path: "/leaves",
        element: <Leaves />,
        auth: authRoles.editor,
      },
      {
        path: "/visitor/list",
        element: <VisitorList />,
        auth: authRoles.editor,
      },
      {
        path: "/plan",
        element: <Plan />,
        auth: authRoles.editor,
      },
      {
        path: "/holiday",
        element: <HolidayCalender />,
        auth: authRoles.editor,
      },
      {
        path: "/holiday/add",
        element: <AddHoliday />,
        auth: authRoles.editor,
      },
      {
        path: "profile/change-password",
        element: <ChangePassword />,
        auth: authRoles.editor,
      },
      {
        path: "/leave/management",
        element: <LeaveType />,
      },
      {
        path: "/leave/tracker",
        element: <LeaveTracker />,
      },
      {
        path: "/leave/balance",
        element: <EmployeeLeaveBalance />,
      },
      {
        path: "/employee_leave",
        element: <EmployeeLeaveList />,
      },
      {
        path: "/leave/adjustment",
        element: <EmployeeLeaveList />,
      },
      {
        path: "/leave/leave-report",
        element: <LeaveReport />,
      },
      {
        path: "/leave/lop-adjustment",
        element: <EmployeLopTab />,
      },
      {
        path: "/add/leavetype",
        element: <AddLeaveType />,
      },
      {
        path: "/leave/setting",
        element: <LeaveCofiguration />,
      },
      //Leave Management system
      {
        path: "/leave/management",
        element: <LeaveType />,
      },
      {
        path: "/leave/tracker",
        element: <LeaveTracker />,
      },
      {
        path: "/leave/adjustment",
        element: <EmployeeLeaveList />,
      },
      {
        path: "/leave/leave-report",
        element: <LeaveReport />,
      },
      {
        path: "/add/leavetype",
        element: <AddLeaveType />,
      },
      {
        path: "/leave/setting",
        element: <LeaveCofiguration />,
      },
      {
        path: "/leave/reconcilation",
        element: <LeaveReconcilation />,
      },
      {
        path: "/cron-job",
        element: <CronJobs />,
      },
    ],
  },
  // Employee module routes
  {
    element: (
      <EmployeeGuard>
        <MatxLayout />
      </EmployeeGuard>
    ),
    children: [
      {
        path: "/employee-dashboard",
        element: <EmployeeDashboard />,
        // auth: authRoles.admin,
      },
      {
        path: "/profiles/profile",
        element: <Profile />,
        auth: authRoles.editor,
      },
      {
        path: "employee-profile/change-password",
        element: <ChangePassword />,
        auth: authRoles.editor,
      },
      {
        path: "/holiday-calendar",
        element: <EmployeeCalendar />,
        // auth: authRoles.admin,
      },
      {
        path: "/attendance",
        // element: <EmployeesTable />,
        element: <EmployeeAttendanceList />,
        auth: authRoles.employee,
      },
      {
        path: "/employee-leave",
        // element: <EmployeesTable />,
        element: <EmployeeLeave />,
        auth: authRoles.employee,
      },
      {
        path: "/my-activity",
        element: <EmployeeActivityLogsData />,
      },
    ],
  },
  // Company module routes
  {
    element: (
      <CompanyGuard>
        <MatxLayout />
      </CompanyGuard>
    ),
    children: [
      {
        path: "/admin/company/details",
        element: <AddCompany />,
        auth: authRoles.editor,
      },
      {
        path: "/system-dashboard",
        element: <SystemDashboard />,
        auth: authRoles.admin,
      },
      {
        path: "/admin/company",
        element: <CompanyList />,
        auth: authRoles.editor,
      },
    ],
  },
  // session pages route
  { path: "*", element: <NotFound /> },

  {
    element: (
      <CheckInOutGaurd>
        <MatxLayout />
      </CheckInOutGaurd>
    ),
    children: [
      {
        path: "/checkInOut",
        // element: <EmployeesTable />,
        element: <Checkinout />,
        auth: authRoles.employee,
      },
    ],
  },

  {
    path: "/",
    element: (
      <LandingPage>
        <HomePage></HomePage>
      </LandingPage>
    ),
  },
  {
    path: "/activity-tracking",
    element: (
      <LandingPage>
        <ActivityTracking></ActivityTracking>
      </LandingPage>
    ),
  },
  {
    path: "/real-time-insight",
    element: (
      <LandingPage>
        <RealTimeInsights></RealTimeInsights>
      </LandingPage>
    ),
  },
  {
    path: "/leave-mangement",
    element: (
      <LandingPage>
        <LeaveMangement></LeaveMangement>
      </LandingPage>
    ),
  },
  {
    path: "/WFH-support",
    element: (
      <LandingPage>
        <WorkFromHome></WorkFromHome>
      </LandingPage>
    ),
  },
  {
    path: "/compliences-report",
    element: (
      <LandingPage>
        <DetailedComplianceReports></DetailedComplianceReports>
      </LandingPage>
    ),
  },
  {
    path: "/visitor-manegement",
    element: (
      <LandingPage>
        <VisitorMangement></VisitorMangement>
      </LandingPage>
    ),
  },
  {
    path: "/pricing",
    element: (
      <LandingPage>
        <Pricing></Pricing>
      </LandingPage>
    ),
  },
  {
    path: "/blogs",
    element: (
      <LandingPage>
        <Blogs></Blogs>
      </LandingPage>
    ),
  },
  {
    path: "/faq",
    element: (
      <LandingPage>
        <FAQ></FAQ>
      </LandingPage>
    ),
  },
  {
    path: "/contact-us",
    element: (
      <LandingPage>
        <ContactUs></ContactUs>
      </LandingPage>
    ),
  },
  {
    path: "/about-us",
    element: (
      <LandingPage>
        <AboutUs></AboutUs>
      </LandingPage>
    ),
  },
  {
    path: "/blog-the-best-way-to-track-time-attendance-of-your-remote-team",
    element: (
      <LandingPage>
        <TheBestWayToTrackTimeAttendanceOfYourRemoteTeam></TheBestWayToTrackTimeAttendanceOfYourRemoteTeam>
      </LandingPage>
    ),
  },
  {
    path: "/blog-hr-technology-trends-to-watch-out",
    element: (
      <LandingPage>
        <HRTechnologyTrendsToWatchOut></HRTechnologyTrendsToWatchOut>
      </LandingPage>
    ),
  },
  {
    path: "/blog-automated-attendance-solutions-the-game-changer-for-Startups-and-smes",
    element: (
      <LandingPage>
        <AutomatedAttendanceSolutions></AutomatedAttendanceSolutions>
      </LandingPage>
    ),
  },
  {
    path: "/blog-optimizing-employee-schedules-with-attendance-management-software",
    element: (
      <LandingPage>
        <OptimizingEmployeeSchedulesWithAttendanceManagementSoftware></OptimizingEmployeeSchedulesWithAttendanceManagementSoftware>
      </LandingPage>
    ),
  },
  {
    path: "/blog-boost-business-efficiency-with-employee-attendance-management-software",
    element: (
      <LandingPage>
        <BoostBusinessEfficiency></BoostBusinessEfficiency>
      </LandingPage>
    ),
  },
  {
    path: "/blog-how-efficient-attendance-management-boosts-productivity-reduces-costs",
    element: (
      <LandingPage>
        <HowBoostsProductivityandReducesCosts></HowBoostsProductivityandReducesCosts>
      </LandingPage>
    ),
  },

  {
    path: "/blog-manual-vs-automated-attendance-management-why-technology-wins",
    element: (
      <LandingPage>
        <AttandanceManagement></AttandanceManagement>
      </LandingPage>
    ),
  },
  {
    path: "/blog-how-attendance-management-software-improves-accuracy-and-saves-time",
    element: (
      <LandingPage>
        <HowAttendanceManagementSoftwareImproves></HowAttendanceManagementSoftwareImproves>
      </LandingPage>
    ),
  },
  {
    path: "/blog-top-benefits-of-implementing-attendance-management-software-in-your-business",
    element: (
      <LandingPage>
        <TopBenefitsofImplementingAttendance></TopBenefitsofImplementingAttendance>
      </LandingPage>
    ),
  },
  {
    path: "/blog-future-of-employee-time-and-attendance-trends-in-management-software",
    element: (
      <LandingPage>
        <TheFutureofEmployeeTime></TheFutureofEmployeeTime>
      </LandingPage>
    ),
  },
  {
    path: "/blog-why-your-company-needs-a-modern-attendance-management-system",
    element: (
      <LandingPage>
        <WhyYourComapnyNeeds></WhyYourComapnyNeeds>
      </LandingPage>
    ),
  },
  {
    path: "/blog-advanced-attendance-tracking-solutions-help-reduce-time-theft",
    element: (
      <LandingPage>
        <AdvancedTrackingSolutionsHelp></AdvancedTrackingSolutionsHelp>
      </LandingPage>
    ),
  },
  {
    path: "/blog-streamlining-hr-operations-the-role-of-attendance-management-software",
    element: (
      <LandingPage>
        <StreamliningHROperations></StreamliningHROperations>
      </LandingPage>
    ),
  },
  {
    path: "/blog-key-features-to-Look-for-in-an-attendance-management-system",
    element: (
      <LandingPage>
        <KeyFeaturestoLookAttandance></KeyFeaturestoLookAttandance>
      </LandingPage>
    ),
  },
  {
    path: "/blog-5-common-attendance-management-challenges-and-how-to-solve-them",
    element: (
      <LandingPage>
        <CommonAttendanceManagement></CommonAttendanceManagement>
      </LandingPage>
    ),
  },
  {
    path: "/blog-boosting-employee-accountability-with-smart-attendance-management-solutions",
    element: (
      <LandingPage>
        <BoostingEmployeeAccountability></BoostingEmployeeAccountability>
      </LandingPage>
    ),
  },
  {
    path: "/blog-enhancing-remote-work-management-with-attendance-management-app",
    element: (
      <LandingPage>
        <Enhancingremotework></Enhancingremotework>
      </LandingPage>
    ),
  },
  {
    path: "/blog-the-importance-of-attendance-management-for-Compliance-and-audits",
    element: (
      <LandingPage>
        <TheImportanceofAttendance></TheImportanceofAttendance>
      </LandingPage>
    ),
  },
  {
    path: "/blog-how-to-choose-the-right-attendance-management-software-for-your-business",
    element: (
      <LandingPage>
        <HowtochoosetherightAttendancemanagement></HowtochoosetherightAttendancemanagement>
      </LandingPage>
    ),
  },
  {
    path: "/blog-real-time-attendance-tracking-benefits-for-large-and-small-businesses",
    element: (
      <LandingPage>
        <RealTimeAttendanceTrackingBenefits></RealTimeAttendanceTrackingBenefits>
      </LandingPage>
    ),
  },
  {
    path: "/login",
    element: (
      <LogInLayout>
        <JwtLogin />
      </LogInLayout>
    ),
  },

  {
    path: "/admin/login",
    element: (
      <LogInLayout>
        <JwtAdminLogin />
      </LogInLayout>
    ),
  },

  {
    path: "/forgot-password",
    element: (
      <LogInLayout>
        <ForgotPassword />
      </LogInLayout>
    ),
  },
  {
    path: "/admin-forgot-password",
    element: (
      <LogInLayout>
        <AdminForgotPassword />
      </LogInLayout>
    ),
  },
  {
    path: "/company-register",
    element: (
      <LogInLayout>
        <JwtLRegisterCompany />
      </LogInLayout>
    ),
  },
  {
    path: "/verify-email",
    element: (
      <LogInLayout>
        <VerifyEmail />
      </LogInLayout>
    ),
  },
  {
    path: "/offer",
    element: (
      <LogInLayout>
        <OfferLanding />
      </LogInLayout>
    ),
  },

  // { path: '/', element: <Navigate to="dashboard/default" /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
